<template>
  <div>
    <div class="flow-wrapper">
      <div class="flow-content">
        <div v-if="CurrentFlowValueCheck">
          <strong class="flow-content-text--blue flow-content-text--big">
            <!-- {{ store.getData('currentFlow') }} -->
            {{ convertUnits(store ? store.getData('currentFlow') : 0, 'gal', 'l').toFixed(0) }}
          </strong>
          <span v-show="store.getData('systemCapacity')">
            {{ $t('messages.flow.of') }} <span class="no-break">
              <strong>{{ convertUnits(store ? store.getData('systemCapacity') : 0, 'gal', 'l').toFixed(0) }}</strong>
            </span> {{ getDenominator('litre', 'gallon', 0) + '/' + $tc('messages.sharedTexts.time.m', 1) }}
          </span>
          <br>
          {{ $t('messages.flow.expectedFlowOf') }} <span class="no-break">
            <strong class="flow-content-text--blue">
              {{ convertUnits(store ? store.getData('expectedFlow') : 0, 'gal/min', 'l/min').toFixed(0) }}
            </strong> {{ getDenominator('litre', 'gallon', 0) + '/' + $tc('messages.sharedTexts.time.m', 1) }}
          </span>
          <p class="flow-information">
            {{ computedCurrentFlowtitle }}
          </p>
          <p class="flow-information">
            {{ computedExpectedFlowtitle }}
          </p>
        </div>
        <div v-else>
          <h3>{{ $t('messages.sharedTexts.status.loading') }}...</h3>
        </div>
      </div>
      <div class="gauge gauge--flow">
        <div
          class="gauge__background"
          :title="`${$t('messages.flow.title')}: ${currentFlow}`"
        >
          <svg
            class="expected-flow"
            width="120"
            height="120"
            viewBox="0 0 120 120"
          >
            <circle
              class="expected-flow__value"
              cx="60"
              cy="60"
              r="54"
              fill="none"
              stroke="#f77a52"
              stroke-width="12"
              :style="{stroke: ComputeStrokeColor, strokeDashoffset: ComputeExpectedFlowGauge}"
            />
          </svg>
          <div class="gauge__dial-center">
            <div class="gauge__dial-center__indicator" />
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="systemCapacity === undefined"
      class="flow-error"
    >
      <p>
        {{ $t('messages.flow.cannotShowFlow') }}
      </p>
    </div>
  </div>
</template>

<script>
import {SocketHandler, UnitSystem} from '@/assets/javascript/mixins/Mixins'
import GaugeLib from '@/assets/javascript/GaugeLib.js'
export default {
  init: false,
  flowGauge: undefined, // link this later
  name: 'FlowGauge',
  mixins: [SocketHandler, UnitSystem],
  props:
  {
    store: {
      type: Object,
      default: function() {
        return{}
      }
    }
  },
  data() {
    return{
    }
  },
  computed: {
    computedRunningStations() {
      return this.store.getData('stations').filter(station => station.isRunning && station.status !== 1).length
    },
    computedExpectedFlowtitle() {
      return this.expectedFlow <= this.systemCapacity
      ? this.$t('messages.flow.expectedInsideLimits')
      : this.$t('messages.flow.expectedOutsideLimits')
    },
    computedCurrentFlowtitle() {
      const flow = this.currentFlow
      const expectedFlow = this.expectedFlow
      const buffer = expectedFlow * 0.1

      if(this.computedRunningStations === 0 && flow !== 0)
        return this.$t('messages.flow.unscheduledFlow')

      return flow >= expectedFlow - buffer && flow <= expectedFlow + buffer
      ? this.$t('messages.flow.normalFlow')
      : this.$t('messages.flow.deviationFlow')
    },
    ComputeStrokeColor() {
      return (this.expectedFlow > this.systemCapacity) ? '#B22222' : '#7C99BA'
    },
    ComputeExpectedFlowGauge() {
      let val = 339.292 - ((254.292 / this.systemCapacity) * this.expectedFlow)
      if(this.expectedFlow > this.systemCapacity) {
        val = 69.867
      }
      return val
    },
    CurrentFlowValueCheck() {
      return(this.currentFlow !== undefined || this.currentFlow < 0)
    },
    ActiveStationCount() {
      return this.store.getData('stations').filter(station => station.isRunning).length
    },
    systemCapacity() {
      // console.log('systemCapacity via FlowGauge.vue: ' + this.store.getData('systemCapacity'))
      return this.store.getData('systemCapacity')
    },
    currentFlow() {
      return this.store.getData('currentFlow')
    },
    expectedFlow() {
      return this.store.getData('expectedFlow')
    }
  },
  watch: {
    systemCapacity() {
      this.toggleGaugeStatus()
    },
    currentFlow() {
      this.toggleGaugeStatus()
    }
  },
  mounted() {
    this.$nextTick(function() {
      this.flowGauge = new GaugeLib()
      this.toggleGaugeStatus()
    })
  },
  methods:
  {
    refreshClick() {
      this.$emit('Refresh')
    },
    updateFlowGauge() {
      let flow = (this.currentFlow !== null) ? this.currentFlow : 0
      this.overloaded = false

      if(flow > this.systemCapacity) {
        flow = this.systemCapacity + 10
        this.overloaded = true
      }
      this.flowGauge.update(flow)
    },
    toggleGaugeStatus() {
      this.flowGauge.config({
        el: '.gauge.gauge--flow ',
        dialStart: -136,
        dialEnd: 136,
        maxValue: this.systemCapacity,
        status: (this.systemCapacity !== null) ? 'active' : 'disabled'
      })
      this.updateFlowGauge()
    }
  }
}
</script>

<style lang="scss">
  .flow-wrapper {
    padding: 4px;
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    align-items: center;
    justify-content: space-around;

    & + .flow-error p {
      margin: 0;
      font-size: 15px;
      line-height: 17px;
      padding: 12px;
      text-align: center;
    }

    .flow-information {
      font-size: 13px;
      line-height: 16px;
      border: 1px solid $color-grey;
      padding: 2px;
    }

    .gauge {
      overflow: visible;
      width: 100%;
      display: flex;
      justify-content: center;
      margin: 0;
    }

    .right-aligned{
      text-align: right;
    }

    .flow-content {
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 10px;

      line-height: 25px;
      font-size: 18px;

      .no-break {
        white-space: nowrap;
      }

      &-text {
        &--blue {
          color: $color-blue-marine;
        }
        &--big {
          font-size: 30px;
        }
      }
    }

    .refresh {
      margin-left: 0;
    }

    table {
      width: 100%;
    }

    tr>td:first-child {
      padding-right: 10px;
    }

    h3, h4 {
      text-align: left;
      text-transform: uppercase;
      margin-top: 0;
    }

    h4 {
      font-size: 14px
    }

    & + .flow-error
    {
      display: block;
      box-shadow: 2px 2px 5px 0px rgba(50,50,50,0.5);
      border-radius: 5px;
      background-color: #c3c7c9;
      padding: 5px;
    }
  }

  div.gauge {
    &--flow, &--flow &__background {
      width: 167px;
      height: 158px;
      margin: 0;
    }

    &--flow {
      .gauge__background .expected-flow {
        width: 72%;
        height: 100%;
        background: transparent;
        display: block;
          transform: translate3d(14.5%,2%,0) rotate(-225deg);
      }
      .gauge__background .expected-flow__value {
          stroke-dasharray: 339.292;
          stroke-dashoffset: 339.292;
          stroke: #7C99BA;
          transition: stroke-dashoffset 0.4s;
      }
      .gauge__background {
        background: url('~@graphics/flow_gauge.svg') center center;
        background-size: cover;
        border-radius: 0;
      }
      .gauge__dial-center {
        transform: translate3d(-85%,-40%,0);
      }
      .gauge__dial-center__indicator {
        height: 0px;
        border: 5px solid transparent;
        background: none;
        box-shadow: none;
        border-bottom: 50px solid black;
        transform: translate3d(-50%,-100%,0) rotate(0);
      }
    }
  }

  @media screen and (min-width: $bp-tablet) {
    .gauge {
      margin-left: 30px;
    }

    .flow-content {
      justify-content: flex-start;
    }
  }
</style>
